// Difficulty tiers per game type, with sports-flavored labels instead of
// plain easy/medium/hard. Derived from how hard each format actually plays.
export type DifficultyTier = 'rookie' | 'pro' | 'allstar';

export const TIER_META: Record<DifficultyTier, { label: string; className: string }> = {
  rookie: {
    label: 'ROOKIE',
    className: 'bg-background/80 backdrop-blur text-green-400 border-green-400/50',
  },
  pro: {
    label: 'PRO',
    className: 'bg-background/80 backdrop-blur text-primary border-primary/50',
  },
  allstar: {
    label: 'ALL-STAR',
    className: 'bg-background/80 backdrop-blur text-secondary border-secondary/50',
  },
};

const TYPE_TIERS: Record<string, DifficultyTier> = {
  'team-roster': 'rookie', // big-name players, broad knowledge
  'logo-reveal': 'pro', // pixelated + grayscale start
  'player-reveal': 'pro',
  'face-zoom': 'allstar', // 9x zoom on a single feature
  'jersey-number': 'allstar', // deep-cut roster knowledge
  'player-older': 'allstar', // birth years are obscure
  'stat-duel': 'allstar', // exact season stat lines are deep cuts
  'stadium-guess': 'pro',
  'higher-lower': 'rookie', // 50/50 comparisons
};

export function difficultyFor(gameType: string): { tier: DifficultyTier; label: string; className: string } {
  const tier = TYPE_TIERS[gameType] ?? 'pro';
  return { tier, ...TIER_META[tier] };
}
